import { jsx as _jsx } from "react/jsx-runtime";
export const SpotifyEmbed = ({ contentInfo }) => {
    const { pathname } = new URL(contentInfo.url);
    const iframeUrl = `https://open.spotify.com/embed${pathname}`;
    return (_jsx("iframe", { allow: "autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture", allowFullScreen: true, height: "152", loading: "lazy", src: iframeUrl, style: {
            border: 'none',
            borderRadius: 6,
            boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
        }, width: "100%" }));
};
//# sourceMappingURL=SpotifyEmbed.js.map